export const environment = {
    production: true,
    appVersion: require('../../package.json').version,
    hosted: false,
    websocketHost: 'www.frogeye.io',
    auth0_config: {
        domain: 'frogeye.us.auth0.com',
        clientId: '8Z8Vj4gCa8uFVRf4PhNUv919KZqgPqVu',
        audience: 'https://www.frogeye.io/api',
        authorizationParams: {
            redirect_uri: window.location.origin,
        },
    },
    stripe_key: 'pk_live_51Jb4rOJVqCwYnsnQXaAfDzPqUyiOMUWNsohdfB2SmTv98bm7YnXfhLunQk81yXbxRJIQd8OZ85PCtaSRprmpU63H00B8cZLy6K',
    recaptchaSiteKey: '6LfvJOkmAAAAAL3UAZsIlo4bTvC3lw_9tuG62XAr',
    sentry_dsn: 'https://8785faecdd0d4771826073f36677891f@o410314.ingest.sentry.io/5284150',
    release: 'prod'
};
